module.exports = __webpack_public_path__ + "static/media/background4.de156e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bg/background4.jpg
// module id = 409
// module chunks = 0